/* ZOALIN_MOBILE_REVIEWS_SPACING_20260719 */
(function () {
  var mediaQuery = window.matchMedia('(max-width: 749px)');
  var styleId = 'zoalin-mobile-reviews-spacing-20260719-style';

  function shouldRun() {
    return mediaQuery.matches && document.body.classList.contains('template-product');
  }

  function ensureStyle() {
    if (document.getElementById(styleId)) return;

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent = [
      '@media(max-width:749px){',
      'html body.template-product #judgeme_product_reviews :is(.jm-review-widget-minimal-header,.jdgm-rev-widg__header){padding-bottom:18px!important;}',
      'html body.template-product #judgeme_product_reviews .jm-no-reviews-state{width:100%!important;max-width:100%!important;margin:-4px auto 0!important;justify-items:center!important;text-align:center!important;}',
      'html body.template-product #judgeme_product_reviews .jm-no-reviews-state__text{display:block!important;width:100%!important;max-width:100%!important;margin:-2px auto 0!important;text-align:center!important;transform:translateY(-4px)!important;}',
      'html body.template-product #judgeme_product_reviews .jm-no-reviews-state__action-buttons{justify-content:center!important;margin-top:6px!important;}',
      '}'
    ].join('');
    document.head.appendChild(style);
  }

  function applySpacing() {
    if (!shouldRun()) return;
    ensureStyle();

    var root = document.querySelector('#judgeme_product_reviews');
    if (!root) return;

    var header = root.querySelector('.jm-review-widget-minimal-header, .jdgm-rev-widg__header');
    var state = root.querySelector('.jm-no-reviews-state');
    var text = root.querySelector('.jm-no-reviews-state__text');
    var actions = root.querySelector('.jm-no-reviews-state__action-buttons');

    if (header) {
      header.style.setProperty('padding-bottom', '18px', 'important');
    }

    if (state) {
      state.style.setProperty('width', '100%', 'important');
      state.style.setProperty('max-width', '100%', 'important');
      state.style.setProperty('margin', '-4px auto 0', 'important');
      state.style.setProperty('justify-items', 'center', 'important');
      state.style.setProperty('text-align', 'center', 'important');
    }

    if (text) {
      text.style.setProperty('display', 'block', 'important');
      text.style.setProperty('width', '100%', 'important');
      text.style.setProperty('max-width', '100%', 'important');
      text.style.setProperty('margin', '-2px auto 0', 'important');
      text.style.setProperty('text-align', 'center', 'important');
      text.style.setProperty('transform', 'translateY(-4px)', 'important');
    }

    if (actions) {
      actions.style.setProperty('justify-content', 'center', 'important');
      actions.style.setProperty('margin-top', '6px', 'important');
    }
  }

  function start() {
    [0, 60, 220, 520, 950, 1900, 3200, 5200].forEach(function (delay) {
      window.setTimeout(applySpacing, delay);
    });

    var observer = new MutationObserver(applySpacing);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.addEventListener('load', applySpacing);
  mediaQuery.addEventListener('change', applySpacing);
})();
